import React from "react";
import { StaticQuery, graphql } from "gatsby";
import "tachyons";

export default ({ src, content, title, imagePosition = 'left' }) => {
  const flexDirection =
    imagePosition === 'left'
      ? 'row'
      : 'row-reverse';

  return (
    <div className="flex flex-wrap items-center justify-around pv5 pa2 mw9 center" style={{ flexDirection }}>
      <img src={src} alt="" />
      <div className="w-100 pa2 mw6 mv4">
        <span className="db f2 display dark-gray">{title}</span>
        <div className="lh-copy f5 serif mt4">{content}</div>
      </div>
    </div>
  );
};
